import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../../../models/GenericTableViewModel";
import { removeClient } from "../../../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../../../models/RouteComponent";
import { removeEquipmentType } from "../../../../service/equipmentTypesService";
import PtoTopicsAdd from "./pto-topics-Add";
import { removePTO } from "../../../../service/ptoService";

export default function PtoTopicsView(props: RouteComponentProps) {
  const [selectedType, setTypes] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    job_task_list: { value: "", matchMode: FilterMatchMode.CONTAINS },
    industry_list: { value: "", matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    removeClient(selectedType.id);
  };

  const addButton = (row: any) => {
    setTypes(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    setTypes(row.value);
    editConfirm(row);
  };

  const contextItemSelected = (row: any) => {
    setTypes(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removePTO(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: "success", summary: "PTO Deleted Successfully", life: 3000 });
  };

  const editConfirm = (row: any) => {
    setVisible(true);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const contextItems = () => {
    let objArray = [{ label: "Edit", icon: "pi pi-fw pi-pencil", command: editConfirm }];
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "job_task_list",
      header: "Job Task",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "industry_list",
      header: "Industry",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          PTO
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="pto-topic"
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={selectedType?.id ? "Update PTO" : "Add PTO"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <PtoTopicsAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedType?.id}
          details={selectedType}
          setVisible={setVisible}
          toast={toast}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
